import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { paths } from './paths';
import GuardedRoute from '../services/guardedRoute';
import lazyRetry from '../services/lazyRetry';

const PageNotFound = React.lazy(() => lazyRetry(() => import('./pages/PageNotFound')));

const RoutesContainer = ({
  isValidUser,
}) => (
  <Routes>
    {paths.map((item) => (
      <Route
       path={item.route}
       element={(
         <GuardedRoute
           defaultpage={item.defaultpage}
           component={item.component}
           isValidUser={isValidUser || (item.auth !== true)}
           authRequired={item.auth} />
       )}
       key={item.route}
       exact={item.exact} />
      // <GuardedRoute component={item.component} isValidUser={isValidUser || (item.auth != true)} authRequired={item.auth} path={item.route} key={item.route} exact={item.exact} defaultpage={item.defaultpage} />
    ))}
    <Route path="*" component={PageNotFound} />
  </Routes>
);

export default RoutesContainer;
